import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  rolesData: [],
  roleList: [],
  error: {},
  permissionsData: [],
  count:0
}

export const fetchRoleData = createAsyncThunk('roleSlice/fetchRoleData', async (payload, thunkAPI) => {
  try {
    let url="/roles";
    if(payload?.minimal){
      url=url+"?minimal=true"
    }
    
    const response = await axiosInstance.get(`${url}${payload?.queryString ? payload.queryString : ""}`);    
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const fetchRoleList = createAsyncThunk('roleSlice/fetchRoleList', async (payload, thunkAPI) => {
  try {
    let url="/roles?page=1&page_size=100&minimal=true";
   
    
    const response = await axiosInstance.get(url);    
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const fetchPermissions = createAsyncThunk('roleSlice/fetchPermissions', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get('/permissions');
    
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const deleteRole = createAsyncThunk('roleSlice/deleteRole', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/roles/${id}`);
    response.data = id
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const createRole = createAsyncThunk('roleSlice/createRole', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.post('/roles', values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const updateRole = createAsyncThunk('roleSlice/updateRole', async (values, thunkAPI) => {
  try {    
    const response = await axiosInstance.patch(`/roles/${values?.id}/permissions`, { permissions: values.permissions, name:values.name });
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const roleSlice = createSlice({
  name: 'roleSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    //fetch all roles
    builder.addCase(fetchRoleData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchRoleData.fulfilled, (state, action) => {
      state.rolesData = action.payload?.data?.results;
      state.count = action.payload?.data?.count;
      state.loading = false;      
    });
    builder.addCase(fetchRoleData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(fetchRoleList.pending, (state) => {
      // state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchRoleList.fulfilled, (state, action) => {
      state.roleList = action.payload?.data?.results;
      // state.loading = false;      
    });
    builder.addCase(fetchRoleList.rejected, (state, action) => {
      // state.loading = false;
      state.error = action.payload;
    });

    //fetch all permissions
    builder.addCase(fetchPermissions.pending, (state) => {
      // state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPermissions.fulfilled, (state, action) => {
      // state.loading = false;
      state.permissionsData = action.payload?.data;
    });
    builder.addCase(fetchPermissions.rejected, (state, action) => {
      // state.loading = false;
      state.error = action.payload;
    });

    //create role
    builder.addCase(createRole.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createRole.fulfilled, (state, action) => {
      state.loading = false;      
      state.rolesData = [action?.payload?.data?.data, ...state.rolesData];
      if(action?.payload?.status==201){
        toast.success("Role created successfully")
      }
    });
    builder.addCase(createRole.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //delete role
    builder.addCase(deleteRole.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteRole.fulfilled, (state, action) => {
      state.loading = false;
      state.rolesData = state.rolesData.filter((ele) => ele.id !== action?.payload?.data);
      if(action?.payload?.status==204){
        toast.success("Role deleted successfully")
      }
    });
    builder.addCase(deleteRole.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //update role
    builder.addCase(updateRole.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateRole.fulfilled, (state, action) => {
      const updatedRole = action.payload?.data?.data;
      state.loading = false;
      if (action.payload.status == 200) {
        state.rolesData = state.rolesData.map(role =>
          role.id === updatedRole.id ? updatedRole : role
        );
        toast.success("Role updated Successfully !")
      }
    });
    builder.addCase(updateRole.rejected, (state, action) => {
      console.log("action", action);
      state.loading = false;
      state.error = action.payload;
    });

  },
})


export default roleSlice.reducer